import { Field, Form } from "formik";
import PhoneInput from "react-phone-input-2";
import styled from "styled-components";
import { device } from "../../stylesheet/breakpoints";
import SVG from "react-inlinesvg";

type Props = {
  addition_position_display?: number;
};

export const Wraper = styled.div<Props>`
  display: flex;
  flex-direction: column;
  width: 100%;
  padding: 30px 10px 50px 10px;
  text-align: center;

  @media ${device.mobile} {
    flex: 1;
    /* height: 100%; */
  }

  @media ${device.desktop} {
    position: relative;
    text-align: end;

    ${({ addition_position_display }) =>
      (addition_position_display ?? 0) === 2
        ? "padding: 20px 30px 10px 10px;"
        : " padding: 20px 10px 10px 30px;"}
  }
`;

export const Title = styled.h1`
  margin-bottom: 6px;
  text-align: start;
  font-weight: normal;
  font-size: 18px;
  line-height: 1.2;
  color: var(--title-text-color);

  @media ${device.desktop} {
    margin-bottom: 15px;
    font-size: 25px;
  }
`;

export const FormBox = styled(Form)`
  margin-bottom: 16px;
  padding: 40px 20px 20px;
  background-color: rgba(45, 55, 72, 0.05);
  text-align: start;

  @media ${device.desktop} {
    margin-bottom: 10px;
    padding: 20px 0 0;
    background-color: transparent;
  }
`;

const BaseInputStyle = `
width: 100%;
  margin-bottom: 10px;
  padding: 13px 20px;
  background-color: transparent;
  border: 0.75px solid var(--bg-back-button);
  border-radius: 3px;
  text-align: start;
  font-weight: 400;
  font-size: 11px;
  line-height: 1.18;
  color: var(--text-color);
  transition: border 250ms linear;

  &.error {
    border: 1px solid red;
  }

  @media ${device.desktop} {
    width: 48%;

    &:nth-child(2n+1) {
      margin: 5px 0px 5px 10px;
    }

    &:nth-child(2n) {
      margin: 5px 10px 5px 0px;
    }
  }

  &::placeholder {
    color: var(--text-color);
  }

  &:hover,
  &:focus,
  &:focus-visible {
    outline: none;
    border: 1px solid var(--bg-button);
  }
`

export const InputContact = styled(Field)`
  ${BaseInputStyle}
`;

// Стилізація PhoneInput на основі BaseInputStyle
export const StyledPhoneInput = styled(PhoneInput)`
  display: inline-block;
  font-family: inherit;
  ${BaseInputStyle};
  padding-left: 50px;

  .form-control {
    background-color: transparent;
    border: none;
    width: 100%;
    padding: 0;
    margin: 0;
    font-size: inherit;
    color: inherit;
    outline: none;

    &:focus {
      border-color: transparent;
      box-shadow: none;
    }
  }

  .country-list {
    max-height: 160px;
  }
  .flag-dropdown {
    left: -4px;
    border: none;
    background-color: transparent;
    padding-right: 8px;
  }

  .selected-flag {
    left: 0px;
  }

  &.error {
    border: 1px solid red;
  }
`;

export const CheckedBox = styled.div`
  width: calc(100% - 40px);
  margin: 0px 20px 20px 20px;

  @media ${device.desktop} {
    width: 100%;
    margin: 0px; //32
    
  }

  & label {
    bottom: 2px;
  }

  & label > p {
    text-align: start;
    padding-top: 4px;
    font-size: 12px; //11
  }
`;

export const TitleBox = styled.span`
  position: relative;
  display: block;
  width: calc(100% - 40px);
  margin: 0px 20px 0px 20px;
  z-index: 0;

  @media ${device.desktop} {
    width: 100%;
    margin: 0px;
  }
`;

export const TitleSocial = styled.h2`
  width: 150px;
  margin: 0 auto;
  margin-bottom: 24px;
  padding-inline: 10px;
  font-weight: 400;
  font-size: 12px; //11
  line-height: 1.2;
  color: var(--text-color);
  background-color: var(--bg-color);
  text-align: center;

  @media ${device.desktop} {
    width: 210px;
    margin-bottom: 20px;
    padding: 4px 20px;
    font-size: 13px;
  }

  &::before {
    content: "";
    position: absolute;
    top: 11px;
    left: 0;
    display: block;
    width: 100%;
    height: 1px;
    background-color: var(--bg-back-button);
    z-index: -1;

    @media ${device.desktop} {
      z-index: -1;
    }
  }
`;

export const BoxSocial = styled.ul`
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(82px, 1fr));
  justify-content: center;
  grid-gap: 25px 20px;
  margin: 0 auto;
  width: calc(100% - 40px);
  margin: 0px 20px 20px 20px;

  

  @media ${device.desktop} {
    width: 100%;
    grid-gap: 20px 14px;
    margin: 0px 0px 20px 0px;
  }
`;

export const ItemSocial = styled.li`
  display: inline-flex;
  flex-direction: row;
  justify-content: flex-start;
  align-items: center;
  color: var(--text-color);
  cursor: pointer;
  transition: color 250ms linear;

  &:hover,
  &:focus {
    color: var(--bg-button);
  }
`;

export const IconBox = styled.span`
  position: relative;
  top: 0px;
  left: 0px;
  width: 13px;
  height: 13px;
  padding: 0;
  margin-right: 12px;
  border-radius: 50%;
  background-color: #fff;

  @media ${device.desktop} {
    margin-right: 7px;
    margin-bottom: 0px;
  }
`;

export const IconSocial = styled(SVG)`
  position: absolute;
  top: -1px;
  left: -1px;
`;

export const TextSocial = styled.span`
  text-transform: capitalize;
  font-size: 11px; //9
  line-height: 1.22;

  @media ${device.desktop} {
    padding-block: 3px;
    font-size: 11px;
    line-height: 1.29;
  }
`;

export const ButtonBox = styled.div<Props>`
  position: absolute;
  bottom: 0px;

  @media ${device.mobile} {
    left: 50%;
    transform: translateX(-50%);
  }

  @media ${device.desktop} {
    bottom: 10px;
    ${({ addition_position_display }) =>
      (addition_position_display ?? 0) === 2 ? "right: 30px;" : "right: 10px;"}
  }
`;

export const BoxBonuse = styled.div`
  display: grid;
  grid-template-columns: minmax(90px, 1fr) minmax(90px, 1fr);
  justify-content: center;
  grid-gap: 20px;
  width: 100%;
  max-width: 100%;
  height: 60px;
  margin-bottom: 20px;
`;
